<template>
  <div>
    <el-table ref="tableRef" :data="pageUsers" style="width: 100%">
      <template v-for="col in cols" :key="col.prop">
        <el-table-column
          v-if="col.format"
          :width="col.width"
          :label="col.name"
          :prop="col.prop"
          :show-overflow-tooltip="true"
        >
          <template class="nameCss" #default="scope">
            <div v-if="col.prop === 'username'">
              <el-badge
                v-if="scope.row['isadmin']"
                value="管理员"
                class="adminitem"
              >
                <span>{{ scope.row["username"] }}</span>
              </el-badge>
              <span v-else> {{ scope.row["username"] }}</span>
            </div>
            <span v-else> {{ col.format(scope.row) }}</span>
          </template>
        </el-table-column>

        <el-table-column
          v-else-if="col.prop == 'apps'"
          width="600"
          :label="col.name"
          :prop="col.prop"
          :show-overflow-tooltip="true"
        >
          <template #default="scope">
            <div v-if="scope.row['isadmin']">
              <span>项目下的全部应用</span>
            </div>
            <span v-else v-for="(app, index) in scope.row.apps" :key="index">
              <span v-if="index != 0">、</span>
              <span>{{ app.name }}&nbsp;</span>
              <i
                :class="['iconfont', 'icon-' + iconEnum[app.platform - 1]]"
              ></i>
            </span>
          </template>
        </el-table-column>

        <el-table-column
          v-else
          :width="col.width"
          :label="col.name"
          :prop="col.prop"
        ></el-table-column>
      </template>

      <el-table-column width="100">
        <template #default="scope">
          <span
            class="button"
            style="font-size: 20px; margin-right: 15px; color: #1f86e4"
            @click="handelEdit(scope.row)"
            ><i class="iconfont icon-bianji1"></i
          ></span>
          <span
            class="button delete"
            style="font-size: 20px"
            @click="handelDelete(scope.row)"
            ><i class="iconfont icon-shanchu"></i
          ></span>
        </template>
      </el-table-column>
    </el-table>

    <Pagination
      :total="filterUsers.length"
      :size="page.size"
      :onPageChange="handleChangePage"
    />

    <UserEdit
      title="编辑用户"
      type="edit"
      ref="editUserRef"
      key="editUser"
      @submit-success="reloadUsersAndGroups"
    />
  </div>
</template>

<script setup>
import {
  computed,
  defineProps,
  defineExpose,
  getCurrentInstance,
  reactive,
  ref,
} from "vue";
import { formatDateTime, formatList } from "@/Utils/UtilTools";
import { storeToRefs } from "pinia";
import { useProjectStore } from "@/Store/ProjectStore";
import UserEdit from "./UserEdit.vue";
import Pagination from "@/Components/Pagination.vue";
import { apiDeleteTester } from "@/Api/AppApi";

const props = defineProps({ filter: String });
defineExpose({ doLayout });

const { appContext } = getCurrentInstance();
const $confirm = appContext.config.globalProperties.$confirm;
const $message = appContext.config.globalProperties.$message;

const projectStore = useProjectStore();
const { currentProjectId, testUsers } = storeToRefs(projectStore);

const page = reactive({ size: 10, current: 0 });
const match = (s) => s && s.includes(props.filter);
const filterUsers = computed(() => {
  if (!props.filter) {
    return testUsers.value;
  }

  return testUsers.value.filter(
    (user) =>
      match(user.email) ||
      match(user.username) ||
      user.groups?.some((g) => match(g.name)) ||
      user.apps?.some((app) => match(app.name))
  );
});
const pageUsers = computed(() => {
  const start = page.current * page.size;
  return filterUsers.value.slice(start, start + page.size);
});

const iconEnum = ["apple", "android", "windows", "app-store", "linux"];

const cols = [
  {
    name: "用户名",
    prop: "username",
    format: function (row) {
      if (row.isadmin === true) {
        return row.username;
      } else {
        return row.username;
      }
    },
  },
  { name: "姓名", prop: "fullname" },
  // {
  //   "name": "类型", "prop": "userchannel",
  //   format: function (row) {
  //     return config.userChannels[row.userchannel] || row.userchannel;
  //   }
  // },
  {
    name: "所属组",
    prop: "groups",
    format: function (row) {
      return formatList(row.groups);
    },
  },

  { name: "所属应用", prop: "apps" },
  {
    name: "加入时间",
    prop: "firstcreated",
    format: function (row) {
      return formatDateTime(row.firstcreated);
    },
  },
];

const editUserRef = ref(null);

function handelEdit(row) {
  editUserRef.value.show({
    username: row.username,
    email: row.username,
    appids: (row.apps || []).map(function (a) {
      return a.appid;
    }),
  });
}

async function handelDelete(row) {
  try {
    await $confirm("删除该用户？", "", {
      type: "warning",
      confirmButtonClass: "el-button el-button--danger",
      closeOnClickModal: false,
    });

    const data = {
      projectid: currentProjectId.value,
      members: [row.username],
    };

    const res = await apiDeleteTester(data);
    if (res.code === 0) {
      reloadUsersAndGroups();
    } else {
      $message.error(res.message);
    }
  } catch (e) {
    // nothing
  }
}

function reloadUsersAndGroups() {
  projectStore.getTestUsers();
  projectStore.getTestGroups();
}

function handleChangePage(p) {
  page.current = p - 1;
}

const tableRef = ref(null);
function doLayout() {
  tableRef.value.doLayout();
}
</script>

<style lang="scss" scoped>
.adminitem {
  margin: 6px 0;
  margin-right: 40px;
}

.delete:hover {
  color: #eb3a2c;
}
.adminitem :deep() {
  .el-badge__content {
    background: #58acf8 !important;
    right: 0 !important;
  }

  .el-badge__content.is-fixed {
    top: 3px !important;
  }
}

.button {
  cursor: pointer;
}
</style>
